import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"cross\"><path d=\"M6.69 7.75l-3.47 3.47a.75.75 0 101.06 1.06l3.47-3.47 3.47 3.47a.75.75 0 101.06-1.06L8.81 7.75l3.47-3.47a.75.75 0 00-1.06-1.06L7.75 6.69 4.28 3.22a.75.75 0 00-1.06 1.06l3.47 3.47z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol